import { ArrowRight, Code2, Gem, Layers, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";

import { PageTitle } from "components/page-title";
import { Badge } from "components/ui/badge";
import { Button } from "components/ui/button";
import { Card } from "components/ui/card";
import * as Routes from "routes";

import { AppAccessIllustration } from "./app-access-illustration";

const gettingStartedOptions = [
  {
    icon: Sparkles,
    title: "Start with a Free subscription",
    description:
      "Create your first app and start exploring the APIs available on the Free plan.",
  },
  {
    icon: Gem,
    title: "Try a paid subscription",
    description:
      "Explore premium APIs and data with a trial of a paid plan. Check the available plans for trial options.",
  },
  {
    icon: Code2,
    title: "Build with Geoscape Verify",
    description:
      "Create apps, choose their APIs and manage API keys to connect Geoscape Verify to your integrations.",
  },
];

export const MyAppsSubscriptionRequired = () => (
  <div className="mx-auto max-w-6xl space-y-6">
    <PageTitle
      icon={Layers}
      title="My Apps"
      description="Create and manage your Geoscape integrations and apps."
    />
    <Card className="gap-0 overflow-hidden p-0">
      <div className="grid lg:grid-cols-2">
        <div className="flex flex-col justify-center p-6 sm:p-10">
          <Badge variant="secondary" className="mb-5 gap-1.5 self-start">
            <Layers aria-hidden="true" />
            Build with Geoscape
          </Badge>
          <h2 className="max-w-md text-3xl font-semibold tracking-tight sm:text-4xl">
            Your next integration starts here.
          </h2>
          <p className="mt-4 max-w-md text-base leading-relaxed text-muted-foreground">
            My Apps gives you access to create Geoscape Verify integrations and
            apps, bringing address, email and phone verification into your own
            products and workflows.
          </p>
          <p className="mt-4 max-w-md text-base leading-relaxed text-muted-foreground">
            You need a subscription to create apps. Start with a Free
            subscription or explore a trial of a paid plan.
          </p>
          <Button asChild size="lg" className="mt-6 self-start">
            <Link to={Routes.orgManageSubscription}>
              View subscription plans
              <ArrowRight aria-hidden="true" />
            </Link>
          </Button>
        </div>

        <AppAccessIllustration />
      </div>

      <div className="grid gap-6 border-t bg-muted/20 p-6 sm:p-8 md:grid-cols-3">
        {gettingStartedOptions.map(({ icon: Icon, title, description }) => (
          <div key={title}>
            <Icon className="mb-3 size-5 text-primary" aria-hidden="true" />
            <h3 className="text-sm font-semibold">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
              {description}
            </p>
          </div>
        ))}
      </div>
    </Card>
  </div>
);
